import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import FlexRow from '../../../../components/molecules/FlexRow'

const useStyles = makeStyles((theme) => ({
  suggestionChip: {
    border: 'var(--dai-border1)',
    backgroundColor: 'var(--dai-color-surface2)',
    transition: 'all 0.2s ease',
    '&:hover': {
      // backgroundColor: 'var(--dai-color-hover)',
      borderColor: 'var(--dai-color-accent)',
      color: 'color-mix(in srgb, var(--dai-color-accent) 50%, var(--dai-color-text))'
    }
  }
}))

function SuggestionChip ({ children, onClick, className }) {
  const classes = useStyles()

  return (
    <FlexRow
      className={clsx(`gap-sm items-center px-3 py-2 radius-lg font-size-xs hover clickable ${classes.suggestionChip}`, className)}
      onClick={onClick}
    >
      <div>
        {children}
      </div>
    </FlexRow>
  )
}

SuggestionChip.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string
}

export default SuggestionChip
